import React from 'react';

export default function HomePage() {
    return <div className="text-center p-2">Home Page</div>;
}
